import React from 'react'
import MenuItem from 'material-ui/MenuItem'

const buildMenuItems = (resource) => {
  return [
    <MenuItem primaryText='Edit' key='edit' value={`/ecommerce/promo-code-discounts/${resource.id}/edit`} />,
    <MenuItem primaryText='Promo Code' key='promoCode' value={`/ecommerce/promo-codes/${resource.promo_code_id}/edit`} />,
    <MenuItem primaryText='Discount' key='discount' value={`/ecommerce/discounts/${resource.discount_id}/edit`} />
  ]
}

export default buildMenuItems
